<template>
    <layout :breadcrumbs="breadcrumbs">
        <template slot="header">
            <h1 class="text-center">
                Select Trim
            </h1>
        </template>

        <b-row class="d-sm-none mobile-header">
            <b-col>
                <h1 class="text-center">
                    Select Trim
                </h1>
            </b-col>
        </b-row>

        <b-row>
            <b-col cols="12" md="7" class="trims-list-container">
                <trims-list
                    v-model="selectedTrim"
                    :trims="trims"
                    @compare-clicked="onCompareClick"
                    @view-all-options="openOptionsModal"
                />
            </b-col>
            <b-col md="5" class="d-none d-sm-block">
                <vehicle-details-loader v-if="isLoading" />
                <affix
                    v-else
                    relative-element-selector=".trims-list-container"
                    :style="{ width: affixWidth }"
                    :offset="{ top: 60, bottom: 20 }"
                >
                    <vehicle-details
                        v-if="selectedTrim"
                        :trim="selectedTrim"
                        :base-trim="baseTrim"
                        @view-all-options="openOptionsModal"
                    />
                </affix>

                <standard-options-modal
                    v-if="selectedTrim"
                    ref="optionsModal"
                    :trim="selectedTrim"
                />
            </b-col>
        </b-row>
    </layout>
</template>

<style lang="scss">
@include media-breakpoint-up(md) {
    .trims-list-container {
        border-right: 1px solid $muted-gray;
    }
}
</style>

<script>
import Layout from "../components/Layout";
import { get, dispatch, call } from "vuex-pathify";
import _ from "lodash";
import TrimsList from "./components/TrimsList";
import VehicleDetails from "./components/VehicleDetails";
import StandardOptionsModal from "./components/StandardOptionsModal";
import VehicleDetailsLoader from "Modules/ShopBy/Make/components/VehicleDetailsLoader";

export default {
    components: {
        VehicleDetailsLoader,
        VehicleDetails,
        TrimsList,
        Layout,
        StandardOptionsModal
    },

    props: {
        makeName: {
            type: String,
            required: true
        },
        modelId: {
            type: String,
            required: true
        },
        bodyType: {
            type: String,
            required: false,
            default: null
        }
    },

    data() {
        return {
            breadcrumbs: [
                {
                    text: "Shop By",
                    href: "/shop-by"
                },
                {
                    text: "Make & Model",
                    to: { name: "make-model" }
                },
                {
                    text: "Trim",
                    active: true
                }
            ],
            selectedTrim: null
        };
    },

    computed: {
        selectedMakeName: get("shopBy/selectedMakeName"),
        styles: get("shopBy/styles"),
        selectedLocation: get("location/selectedLocation"),
        isLoading: get("shopBy/loading"),
        trims() {
            // When coming from the Core 4, do not show trims that are not core4enabled.
            const core4Enabled =
                _.get(this.$route, "query.core4", "true") === "true";
            const core4Trims = _.chain(this.styles)
                .filter(["core4Enabled", true])
                .filter(style => {
                    if (!_.isNil(this.bodyType)) {
                        return style.bodyType === this.bodyType;
                    }
                    return true;
                })
                .orderBy("sequence")
                .value();
            // If not coming from core4, prefer core4enabled trims, but if none found, then return all trims.
            if (core4Enabled || _.size(core4Trims) > 0) {
                return core4Trims;
            }

            return _.chain(this.styles)
                .filter(style => {
                    if (!_.isNil(this.bodyType)) {
                        return style.bodyType === this.bodyType;
                    }
                    return true;
                })
                .orderBy("sequence")
                .value();
        },

        baseTrim() {
            const selectedIndex = _.findIndex(this.trims, {
                id: _.get(this.selectedTrim, "id")
            });
            if (selectedIndex === 0) {
                return null;
            }
            return this.trims[selectedIndex - 1];
        },

        affixWidth() {
            if (window.innerWidth >= 1440) {
                return "445px";
            } else if (window.innerWidth >= 1024) {
                return "390px";
            }

            return "290px";
        }
    },

    watch: {
        isLoading(loading) {
            if (!loading) {
                this.selectedTrim = _.head(this.trims);
            }
        }
    },

    created() {
        if (
            _.isNil(this.selectedMakeName) ||
            this.selectedMakeName !== this.makeName
        ) {
            dispatch("shopBy/addFilter", {
                name: "makes",
                value: this.makeName
            });
        }

        if (!_.isNil(this.selectedMakeName)) {
            dispatch("shopBy/addFilter", {
                name: "makes",
                value: this.makeName
            });
            this.getStylesByModelId(this.modelId);
            this.getModelCountNationwide({
                bodyStyle: this.bodyType,
                modelId: this.modelId
            });
        }

        if (_.isNil(this.selectedLocation)) {
            this.loadLocation();
        }
    },

    methods: {
        getStylesByModelId: call("shopBy/getStylesByModelId"),
        getModelCountNationwide: call("shopBy/getModelCountNationwide"),
        loadLocation: call("location/loadLocation"),

        onCompareClick() {
            this.$router.push({
                name: "compare",
                params: { makeName: this.makeName, modelId: this.modelId }
            });
        },

        openOptionsModal() {
            this.$refs.optionsModal.show();
        }
    }
};
</script>
